import React, { useEffect, useState } from 'react'
import adminStyles from './adminStyles.module.css'
import { useNavigate, useParams } from 'react-router-dom'
import axios from 'axios'

const EditOffer = () => {
     const[oname,setOname]=useState([""])
      const[odesc,setOdesc]=useState("")
  const[datetime,setDatetime]=useState("")
      
    const{sid}=useParams();
    const navigate=useNavigate();

     useEffect(()=>{
    axios.get(`https://backendsurgylife-1.onrender.com/offer/${sid}`)
    .then((res)=>{
        setOname(res.data.oname)
        setOdesc(res.data.odesc)
        setDatetime(res.data.datetime)
    })
    .catch((err)=>{
      alert("Error Fetching offers")
    })
  },[])

  const updateOfferData=(e)=>{
    e.preventDefault()
    axios.put(`https://backendsurgylife-1.onrender.com/offer/${sid}`,{
      oname,
      odesc,
      datetime,
    })
  .then((res)=>{
    alert("Offer Updated Successfully")
    navigate("/admindashboard/deleteoffer")
  })
   .catch((err)=>{
    alert("Error while Updating offer")
   })
  }

  return (
  <main className={adminStyles.adminMain}>
           
                   <section className={adminStyles.breadgum}>
                       <div className='container'>
                           <div className='row'>
                               <div className='col-md-12'>
                                   <h1>Edit Offer</h1>
                               </div>
                           </div>
                       </div>
                   </section>

                                <section className='py-5'>
                                  <div className='container'>
                                     <div className='row'>
                                         <div className='col-md-6 mx-auto' >
                     
                                          <div className={adminStyles.bx_shadow}>
                                           <form onSubmit={updateOfferData}>
                                           <div className='mb-3'>
                     
                                                     <input 
                     
                                                      type='text'
                                                      name='oname'
                                                       placeholder='Offer Name' 
                                                       className='form-control'
                                                       value={oname}
                                                       onChange={
                                                         (e)=>setOname(e.target.value)
                                                       }
                                                       />
                     
                                                       </div>
                     
                                                       <div className='mb-3'>
                     
                                                        <textarea 
                                                        className='form-control'
                                                        placeholder='Offer Description'
                                                        value={odesc}
                                                        onChange={
                                                         (e)=>setOdesc(e.target.value)
                                                        }
                                                        >
                     
                                                        </textarea>
                     
                                                       </div>


                                                       
                                    <div className='mb-3'>
                                <input 
                                 type='dateTime-local'
                                 name='datetime'
                                  placeholder='Offer Expires' 
                                  className='form-control'
                                  value={datetime}
                                  onChange={
                                    (e)=>setDatetime(e.target.value)
                                  }
                                  /> </div>


                     
                                                         <div className='mb-3'>
                                                           
                                                     <input 
                                                     type='submit' 
                                                     value='Update Offer'
                                                     className='btn btn-success'/>  
                     
                                                         </div>
                     
                                                      </form>
                     
                                               
                     
                                                     </div>
                     
                                                    </div>
                                                </div>
                                            </div>
                                        </section>

                   </main>
  )
}

export default EditOffer
